import { useProductsContext } from "../../contexts";
import CategoryCard from "./CategoryCard";
import commonObj from '../../../utils/Common';


const CategoryList = ({ catRef }) => {
  const { categoryList,categoryType } = useProductsContext();
  const groupedByType = categoryList?.list?.rows.reduce((acc, item) => {
    const key = item.type;
    if (!acc[key]) {
        acc[key] = [];
    }
    acc[key].push(item);
    return acc;
}, {});

// const isTransportCategory =
//   categoryType?.[0]?.action === 'TRANSPORT_CAT' &&
//   categoryType?.[0]?.data === '1';

const transportCategories = groupedByType?.transportation ?? [];

// const isProductCategory =
//   categoryType?.[1]?.action === 'PRODUCT_CAT' &&
//   categoryType?.[1]?.data === '1';

const productCategories = groupedByType?.product ?? [];
//console.log(categoryType[0]?.action,'fff');

  return (
    <>
     <section className="product_categories_section px-[6%]">
      <h1 className="break-words text-left maincat">
        {commonObj.getLabel('Categories')}
      </h1>
      <div
        className="grid  grid-cols-1  md:grid-cols-3    gap-4  py-4 mt-1 "
        ref={catRef}
      >
   
        {categoryType?.isTransportCategory &&
         transportCategories?.map((categoryItem) => (
          <CategoryCard key={categoryItem?.id} category={categoryItem} url={categoryList?.url} type='transportations' />
        ))}

        {categoryType?.isProductCategory &&
         productCategories?.map((categoryItem) => (
          <CategoryCard key={categoryItem?.id} category={categoryItem} url={categoryList?.url} type='products'/>
        ))}
       
      </div>
      </section>
    </>
  );
};

export default CategoryList;
